module.exports = __webpack_public_path__ + "static/media/file-earmark.45a0bbfa.svg";